import { Box } from '@talos/kyoko';
import styled from 'styled-components';

export const PriceGridHeaderContainer = styled(Box)`
  align-items: flex-start;
  align-content: flex-start;
  border-bottom: 1px solid var(--backgroundDivider);
  column-gap: ${({ theme }) => theme.spacing8}px;
  display: flex;
  flex-wrap: wrap;
  min-height: 40px;
  padding: ${({ theme }) => `${theme.spacing8}px ${theme.spacing12}px`};
  row-gap: ${({ theme }) => theme.spacing8}px;
  width: 100%;
`;

export const PriceGridHeaderFilters = styled(Box)`
  align-items: center;
  display: flex;
  flex: 1 0 auto;
  flex-wrap: wrap;
  column-gap: ${({ theme }) => theme.spacing8}px;
  max-width: 100%;
  min-width: 0;
  row-gap: ${({ theme }) => theme.spacing8}px;
`;

export const PriceGridHeaderActions = styled(Box)`
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  flex-wrap: nowrap;
  gap: ${({ theme }) => theme.spacing8}px;
  margin-left: auto;
`;

export const PriceGridBody = styled(Box)`
  flex: 1 1 0;
  min-height: 0;
  width: 100%;
`;
